<template>
    <div v-if="nodata" class="customized">
        <md-result-page img-url="/static/icon/noassets.png" text="There are no sales orders at the moment. If you have enabled consignment, please check the authorization of the key partner and whether the kyc partner can receive payment normally or contact customer service in time">
        </md-result-page>
        <md-button class="mt-6" type="primary" round @click="go_sell">Check Sell state </md-button>
    </div>
    
    <div class="scroll-list" v-else>
        <md-scroll-view  ref="listscrollView" :scrolling-x="false" @refreshing="$_onRefresh" :auto-reflow="true" :immediate-check-end-reaching="true"
            @end-reached="$_onEndReached">
            <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                refresh-text="pull to refresh" refresh-active-text="release refreshable"
                refreshing-text="refresh"></md-scroll-view-refresh>
            <md-field class="historylist pt-0">
                <sellhistoryitem :order="order" v-for="order in order_list" v-bind:key="order.id"></sellhistoryitem>
            </md-field>
            <md-scroll-view-more slot="more" :is-finished="isFinished" loading-text="Loading" finished-text="no more data">
            </md-scroll-view-more>
        </md-scroll-view>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import sellhistoryitem from '@/views/my/sellhistoryitem'
import { getsellhistory } from '@/request/api'

export default {
    name: 'sellhitorylist',
    props: {
        status: {
            type: String,
            default: 'paying'
        }
    },
    components: {
        iconimg,
        sellhistoryitem
    },
    data() {
        return {
            order_list: [],
            page: 1,
            limit: 10,
            isFinished: false,
            nodata: false,
        }
    },
    created() {
    },
    mounted() {
        window.ScrollViewTrigger2 = () => {
            this.$refs.listscrollView.triggerRefresh();
        }
    },

    methods: {
        $_onRefresh() {
            this.order_list = [];
            this.page = 1;
            this.get_list(true);
        },
        $_onEndReached() {
            if (this.isFinished) {
                return
            }
            this.get_list(false);
        },
        get_list(refresh) {
            this.$toast.loading("Loading..")
            getsellhistory({
                page: this.page,
                limit: this.limit,
                status: this.status
            }).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    if (res.data.count === 0) {
                        this.nodata = true;
                    } else {
                        this.order_list = this.order_list.concat(res.data.result);
                    }
                    if (this.order_list.length < res.data.count) {
                        this.page = this.page + 1;
                        this.isFinished = false;
                    } else {
                        this.isFinished = true;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if(refresh) {
                    this.$refs.listscrollView.finishRefresh();
                    this.$refs.listscrollView.finishLoadMore();
                } else {
                    this.$refs.listscrollView.finishLoadMore();
                }
            })
        },
        go_sell() {
            this.$router.push('/sell');
        }
    }
}
</script>
<style scoped>
.scroll-list {
    height: 14rem;
}
.mtime {
    color: #666;
    font-size: 24px;
}

.customized {
    height: 6.76rem;
}
.customized >>> .md-result {
    height: 75% !important;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/sellhitorylist.vue